import { Button, styled } from '@/theme/index';

export const StyledButton = styled(Button)(({ theme }) => ({
  alignSelf: 'flex-start',
  borderRadius: '100px',
  borderColor: theme.palette.background.paper,
  color: theme.palette.primary.contrastText,

  '&:hover': {
    borderColor: theme.palette.background.paper,
  },
}));
